<ngx-loading-bar [height]="'3px'" [color]="'#FFC434'" [includeSpinner]="true" [diameter]="'18px'"></ngx-loading-bar>

<div class="app-container">
   <div class="header d-flex justify-content-between">
      <div class="logo-img"></div>

      <div class="header-actions d-flex">
         @if (authService.customerName && !isOrgingLoggedIn) {
         <div ngbDropdown class="dropdown-userinfo d-inline-block" [placement]="'bottom-right'">
            <button type="button" class="btn btn-light" id="dropdownUserinfo" ngbDropdownToggle>
               <telenet-icon name="user"></telenet-icon>
               <span class="user-info-text">{{authService.customerName}}</span>
               <telenet-icon class="chevron-down" name="chevron-down"></telenet-icon>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownUserinfo">
               <div class="user-info">
                  <div class="user-label">
                     <div class="label">{{'MC_USERNAME' | translate}}</div>
                     <div>{{authService.username}}</div>
                  </div>
                  <div class="user-label">
                     <div class="label">{{'MC_INVOICINGDETAILS_CUSTOMERNR' | translate}}</div>
                     <div>{{authService.userId}}</div>
                  </div>
               </div>
               <button type="button" ngbDropdownItem class="my-2" [routerLink]="'/ng/account/overview'">
                  <span> {{'MC_MNU_HOME' | translate}} </span>
               </button>
               <button type="button" class="btn btn-telenet btn-logout" (click)="logout()">{{'MC_LOG_OUT' | translate}}</button>
            </div>
         </div>
         } @else {

   @if (!isOrgingLoggedIn && !hideOrderProductLoginButtons) {

      <button type="button" class="btn btn-telenet btn-login" (click)="register()">{{'MC_REGISTER' | translate}}</button>
      <button type="button" class="btn btn-telenet btn-login ml-3" (click)="login()">{{'MC_LOG_IN' | translate}}</button>
   
   }

         }
         <div ngbDropdown class="dropdown-languages d-inline-block">
            <button type="button" class="btn btn-light" id="dropdownLanguages" ngbDropdownToggle>
               <span>{{selectedLanguage}}</span>
               <telenet-icon class="chevron-down" name="chevron-down"></telenet-icon>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownLanguages">
               <button type="button" ngbDropdownItem [class.selected]="selectedLanguage ==='NL'" (click)="changeLanguage('N')">NL</button>
               <button type="button" ngbDropdownItem [class.selected]="selectedLanguage ==='FR'" (click)="changeLanguage('F')">FR</button>
               <button type="button" ngbDropdownItem [class.selected]="selectedLanguage ==='EN'" (click)="changeLanguage('E')">EN</button>
            </div>
         </div>
      </div>
   </div>
   <!-- <div class="content" *ngIf="authService.customerName || isOriginPage; else maintenanceRouterOutlet">
      <div class="navigation" *ngIf="!isOriginPage && !authService.isOriginSsoAuthenticated">
         <my-cloud-navigation></my-cloud-navigation>
      </div>
      <div class="container-fluid" [class.animate]="isLoading">
         <router-outlet *ngIf="!isLoading"></router-outlet>
      </div>
   </div> -->
   <div class="content">
      @if ((authService.customerName || isOriginPage) && !isOriginPage && !authService.isOriginSsoAuthenticated) {
      <div class="navigation">
         <my-cloud-navigation></my-cloud-navigation>
      </div>
      }
      <div class="container-fluid" [class.animate]="isLoading">
         @if (!isLoading) {
            <router-outlet></router-outlet>
         }
      </div>
   </div>
   <div class="footer">
      <span [innerHTML]="'MC_MYACCOUNT_FOOTER' | translate"></span>
   </div>
</div>





<ng-template #maintenanceRouterOutlet>
   <router-outlet></router-outlet>
</ng-template>